module.exports = __webpack_public_path__ + "ba6cad25afe01d394e830f548a7f94df.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/Source_Sans_Pro/SourceSansPro-Regular.ttf
// module id = 1324
// module chunks = 0